import React, { useState, useContext, useEffect } from "react";
import axios from "axios";
import { Redirect, useHistory } from "react-router";
import { Card, Row, Col, CardBody, CardHeader} from "reactstrap";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import validator from "validator";
import "react-toastify/dist/ReactToastify.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import YouTubeIcon from "@material-ui/icons/YouTube";
import {
  faRupeeSign,
  faClock,
  faDownload,
} from "@fortawesome/free-solid-svg-icons";
import MaterialComponent from "../Learner/LearnerAssesment/MaterialComponent";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import Spinner from "../sample/spinner";
import CircularProgress from "@material-ui/core/CircularProgress";
import Button from "@material-ui/core/Button";
import "../../css/course-catelog.css";
import { UserContext } from "../../context/UserContext";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Typography from "@material-ui/core/Typography";
import AccessTimeIcon from '@material-ui/icons/AccessTime';

const tableStyle = {
  border: "none",

  boxShadow: "none",
  width: "100%",
  bordercollapse: "collapse",
  borderbottom: "1px solid #ddd",
};
const certificateStyle = {
  paddingtop: "15px",
  paddingbottom: "15px",
};
const zoom = {
  transition: "transform .2s",
};

  

const ExploreCoursepage = () => {
  //const classes = useStyles();
  const history = useHistory();
  const context = useContext(UserContext);
  const [topiclist, setTopiclist] = useState([]);
  const [feestrans, setFeestrans] = useState([]);
  const [coursesylbus, setCoursesylbus] = useState([]);
  const [exampolicylist, setExampolicylist] = useState([]);
  const [outlinelist, setOutlinelist] = useState([]);

  const [courseowner, setCourseowner] = useState("");
  const [coursename, setCoursename] = useState("");
  const [imgpath, setImgpath] = useState("");
  const [courseAbbr, setCourseAbbr] = useState("");
  const [batchstartdate, setBatchstartdate] = useState("");
  const [description, setDescription] = useState("");
  const [avatarpath, setAvatarpath] = useState("");
  const [yearofExp, setYearofExp] = useState("NA");
  const [orgName, setOrgName] = useState("NA");
  const [learnerName, setLearnerName] = useState("");
  const [learneremail, setLearneremail] = useState("");
  const [learnermob, setLearnermob] = useState("");
  const [certificatepath, setCertificatepath] = useState("");
  const [blink, setBlink] = useState("");
  const [courseVideopath, setCourseVideopath] = useState("");
  const [courseVideoid, setCourseVideoid] = useState("");
  const [staticlink, setStaticlink] = useState("");
  const [courseid, setCourseid] = useState("");

  const [showcomponent, setShowcomponent] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isdownload, setIsdownload] = useState(false);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const [url, setUrl] = useState(
    "https://dashboard.eduplusnow.com/apiHandler/course"
  );
  useEffect(() => {
    // Update the document title using the browser API

    getexplorecoursedetails();
    // if (process.env.NODE_ENV === "development") {
    //   setUrl("http://localhost:8080/apiHandler/course");
    // } else if (process.env.NODE_ENV === "test") {
    //   setUrl("https://beta.dashboard.eduplusnow.com:8443/apiHandler/course");
    // } else {
    //   setUrl("https://beta.dashboard.eduplusnow.com:8443/apiHandler/course");
    // }
    setUrl(process.env.REACT_APP_PAYMENT_REDIRECTION_URL+"apiHandler/course")
    // document.addEventListener('contextmenu', (e) => {
    //   e.preventDefault();
    // });
    // document.onkeydown = function (e) {

    //   // disable F12 key
    //   if(e.keyCode === 123) {
    //       return false;
    //   }

    //   // disable I key
    //   if(e.ctrlKey && e.shiftKey && e.keyCode === 73){
    //       return false;
    //   }

    //   // disable J key
    //   if(e.ctrlKey && e.shiftKey && e.keyCode === 74) {
    //       return false;
    //   }

    //   // disable U key
    //   if(e.ctrlKey && e.keyCode === 85) {
    //       return false;
    //   }
    //}
  }, [window.location.pathname.replace("/Explore/", "")]);
  const getexplorecoursedetails = async () => {
    setShowcomponent(true);
    var varvalue = window.location.pathname.replace("/Explore/", "");

    let formData = new FormData();
    formData.append("id", varvalue);
    axios
      .post("ExploreCourse/explorecoursreview", formData)
      .then((res) => {
        if (res.data.status === "200" || res.data.status === "100") {
          console.log(" res.data.flag  =" + res.data.flag);
          setShowcomponent(false);
          if (res.data.flag == true) {
            toast.error("Please Login to view course", {
              position: toast.POSITION.BOTTOM_LEFT,
            });
            history.push("/Signin");

            return;
          }
          // setCertificatecourselist(res.data.certificatecourselist);
          setCourseowner(res.data.courseowner);
          setCoursename(res.data.coursename);
          setImgpath(res.data.imgpath);
          setCourseAbbr(res.data.courseAbbr);
          setBatchstartdate(res.data.batchstartdate);
          setFeestrans(res.data.feestrans);
          setDescription(res.data.description);
          setAvatarpath(res.data.avatarpath);
          if(res.data.yearofExp!=="NA")
          {
            setYearofExp(res.data.yearofExp);
          }
          if(res.data.orgName!=="NA")
          {
          setOrgName(res.data.orgName);
          }
          setCoursesylbus(res.data.coursesylbus);
          setExampolicylist(res.data.exampolicylist);
          setLearnerName(res.data.learnerName);
          setLearneremail(res.data.learneremail);
          setLearnermob(res.data.learnermob);
          setTopiclist(res.data.topiclist);
          setOutlinelist(res.data.outlinelist);
          setCertificatepath(res.data.certificatepath);
          setStaticlink(res.data.staticlink);
          setCourseid(res.data.courseid);
          setCourseVideopath(res.data.courseVideopath);
          setCourseVideoid(res.data.courseVideoid);
          setShowcomponent(false);
          setFlag(res.data.flag);

          // setCertificatecourselist(res.data.certificatecourselist);

          return res;
        }
        throw res;
      })
      .catch((error) => {
        let msg = "";
        if (error.response) {
          msg = "Something went wrong.";
        } else if (error.request) {
          msg = "Please try again.";
        } else {
          msg = "Un-expected error.";
        }
        toast.error(msg, {
          position: toast.POSITION.BOTTOM_LEFT,
        });
      });
  };

  const sleep = (milliseconds) => {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  };
  const openModal = () => {
    setModalIsOpen(true);
  };
  const closeModal = () => {
    setModalIsOpen(false);
    setIsdownload(false);
  };
  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    savedetails();
  };

  const savedetails = async () => {
    // setShowcomponent(true)
    if (learnerName === "") {
      toast.error("Name is required");
      await sleep(3000);
      setIsLoading(false);
      return;
    } else if (learneremail === "") {
      toast.error("Email is required");
      await sleep(3000);
      setIsLoading(false);
      return;
    } else if (learnermob === "") {
      toast.error("Contact no is required");
      await sleep(3000);
      setIsLoading(false);
      return;
    } else if (!validator.isEmail(learneremail)) {
      toast.error("Please enter valid email");
      await sleep(3000);
      setIsLoading(false);
      return;
    } else if (
      learnermob === null ||
      learnermob.length < 6 ||
      learnermob.length > 10
    ) {
      toast.error("Please enter valid Phone no , without prefix ");
      await sleep(3000);
      setIsLoading(false);
      return;
    } else {
      var formData = new FormData();

      formData.append("name", learnerName);
      formData.append("email", learneremail);
      formData.append("contact", learnermob);
      formData.append("courseName", staticlink);

      await axios
        .post("ExploreCourse/contactMe3", formData)

        .then((res) => {
          console.log("res  ====");
          if (res.data.status === "200" || res.data.status === "100") {
            setIsLoading(false);
            setBlink(res.data.link);
            setIsdownload(true);
            // window.location.reload(true);
          } else {
            toast.error("Something went wrong");
          }
        });
    }
  };
  if (!context.user?.email) {
    return <Redirect to="/Signin" />;
  }
  // if(flag == true){
  //   history.push("/Signin");
  // }

  return (
    <div>
      <br />
      {showcomponent === true ? (
        <>
          <Spinner />
        </>
      ) : (
        <>
          <section class="explorecourses padding-default">
            <Row>
              <Col lg={8}>
                <Card>
                  <CardHeader>
                    <b>Courses Info</b>
                  </CardHeader>
                  <CardBody>
                    <div class="row">
                      <div class="col-lg-5">
                        <img
                          alt="img"
                          class="img-fluid img-responsive"
                          src={imgpath}
                          style={{ width: "100%" }}
                          height="220"
                        />
                      </div>
                      <div class="col-lg-7">
                        <h4> {coursename}</h4> <br></br>
                        <p>{courseAbbr}</p>
                        <p>
                          {" "}
                          <b>Created by</b>
                          <span class="text-purple"> {courseowner}</span>{" "}
                        </p>
                        {courseVideopath && courseVideopath != "NA" ? (
                      <>
                        <div class="videoe-main">
                          <div class="promo-video">
                            <div class="waves-block">
                              <div class="waves wave-1"></div>
                              <div class="waves wave-2"></div>
                              <div class="waves wave-3"></div>
                            </div>
                          </div>
                          <YouTubeIcon onClick={toggle} className="yu-icon" />
                        </div>
                        <Button  onClick={toggle}><span className="pl-3 text-capitalize">Watch Intro Video</span></Button>
                        {/* color="danger">buttonLabel</Button> */}
                        <Modal isOpen={modal} toggle={toggle} >
                          <ModalHeader toggle={toggle}>Intro Video</ModalHeader>
                          <ModalBody>
                          <div
                              style={{
                                display: "flex",
                                flexdirection: "column",
                                alignitems: "center",
                              }}
                            >
                              <video
                                className="crs-video"
                                controls
                                // autoPlay
                                src={courseVideopath}
                              />
                            </div>
                          </ModalBody>
                        </Modal>
                        <br />
                        </>):(<></>)}
                        <p className="pt-3">
                          <b>Description :</b>
                          {description}
                        </p>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
              <Col lg={4}>
                <Card>
                  <CardHeader>
                    <br />
                  </CardHeader>
                  <CardBody>
                    {batchstartdate !== null ? (
                      <section>
                        <div class="row ">
                          <div class="col-md-12 col-sm-12 text-center">
                            <h6 className="font-weight-bold">Batch Starts On</h6>
                            <p className="text-center font-weight-bold"><AccessTimeIcon color="primary" />{batchstartdate}</p>
                          </div>
                        </div>
                      </section>
                    ) : (
                      ""
                    )}
                    <br />

                    {feestrans.map((item) => (
                      <>
                        {feestrans.length > 1 ? (
                          <>
                            <div
                              class=" col-md-12 col-sm-12 text-center"
                              style={{
                                border: "3px solid rgb(212, 212, 212)",
                              }}
                            >
                              <center>
                                {item.certificationname}
                                <br />
                                {item.discountfees ? (
                                  <>
                                    Original Price :&nbsp;
                                    <span
                                      style={{
                                        textDecorationLine: "line-through",
                                        textDecorationStyle: "solid",
                                      }}
                                    >
                                      <FontAwesomeIcon style={{color:"#ffb500"}} icon={faRupeeSign} />{" "}
                                      <b>{item.fees} </b> 
                                    </span>
                                    <br />
                                    Offer Price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                                    <FontAwesomeIcon style={{color:"#ffb500"}} icon={faRupeeSign} />{" "}
                                   <b> {item.discountfees} </b>
                                  </>
                                ) : (
                                  <>
                                    <FontAwesomeIcon style={{color:"#ffb500"}} icon={faRupeeSign} />{" "}
                                    <b> {item.fees}</b>
                                  </>
                                )}
                                <br />
                                {/* <Link
                                      to={{
                                        pathname: "/Payment/" + staticlink,
                                        state: {
                                          coursefeeid: item.crsfee,
                                          courseid: courseid,
                                          user: localStorage.getItem("user"),
                                        },
                                      }}
                                    >
                                      <button
                                        color="primary"
                                        style={{ borderRadius: 50 }}
                                        className=" btn btn-getstarteds"
                                      >
                                        Select {item.button}
                                      </button>
                                    </Link> */}
                                <form
                                  id="nonseamless"
                                  method="post"
                                  name="redirect"
                                  action={url}
                                >
                                  <input
                                    type="hidden"
                                    name="encResp"
                                    value={item.encRequest}
                                  />
                                  <input
                                    type="hidden"
                                    name="accesskey"
                                    value="eduplusnow"
                                  />
                                  <button className=" btn btn-getstarteds">
                                    Select {item.button}
                                  </button>
                                </form>
                                <br />{" "}
                              </center>
                            </div>
                            <div class=" col-md-1 col-sm-1"> </div>
                          </>
                        ) : (
                          <div class="col-md-12 col-sm-12 text-center">
                            {item.discountfees ? (
                              <>
                                {" "}
                                Original Price :&nbsp;
                                <span
                                  style={{
                                    textDecorationLine: "line-through",
                                    textDecorationStyle: "solid",
                                  }}
                                >
                                  <FontAwesomeIcon style={{color:"#ffb500"}} icon={faRupeeSign} />{" "}
                                  <b>{item.fees}</b>
                                </span>
                                <br />
                                Offer Price &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:{" "}
                                <FontAwesomeIcon style={{color:"#ffb500"}} icon={faRupeeSign} />{" "}
                                <b>{item.discountfees}</b>
                              </>
                            ) : (
                              <>
                                <FontAwesomeIcon style={{color:"#ffb500"}} icon={faRupeeSign} />{" "}
                                <b>{item.fees}</b>
                              </>
                            )}
                            <br />
                            {/* <Link
                                  to={{
                                    pathname: "/Payment/" + staticlink,
                                    state: {
                                      coursefeeid: item.crsfee,
                                      courseid: courseid,
                                      user: localStorage.getItem("user"),
                                    },
                                  }}
                                >
                                  <button
                                    color="primary"
                                    style={{ borderRadius: 50 }}
                                    className=" btn btn-getstarteds"
                                  >
                                    Enroll Now
                                  </button>
                                </Link> */}
                            <form
                              id="nonseamless"
                              method="post"
                              name="redirect"
                              action={url}
                            >
                              <input
                                type="hidden"
                                name="encResp"
                                value={item.encRequest}
                              />
                              <input
                                type="hidden"
                                name="accesskey"
                                value="srv_media"
                              />
                              <button className=" btn btn-getstarteds">
                                Enroll Now
                              </button>
                            </form>
                            <br />
                          </div>
                        )}
                      </>
                    ))}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </section>
          <br /> <br />
          <section class="explorecourses padding-default">
            <Row>
              <Col sm={12}>
                <Card>
                  <CardBody>
                    {/* {courseVideopath && courseVideopath != "NA" ? (
                      <>
                        <div class="row explore-desc">
                          <div class="col-sm-6">
                            <h5>Introductory Video</h5>
                            <div
                              style={{
                                display: "flex",
                                flexdirection: "column",
                                alignitems: "center",
                              }}
                            >
                              <video
                                className="crs-video"
                                controls
                                // autoPlay
                                src={courseVideopath}
                              />
                            </div>
                          </div>

                          <div class="col-sm-6 txt-block">
                            <h5>Description</h5>
                            <p>{description}</p>
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div class="row">
                          <div class="col-lg-8">
                            <h5>Description</h5>
                            <p>{description}</p>
                          </div>
                        </div>
                      </>
                    )} */}

                    <div class="row">
                      <div class="col-lg-9">
                        {/* <h5>Description</h5>
                      <p>{this.state.description}</p> */}

                        <div class="pull-left">
                          <h5>Course Content</h5>
                        </div>
                        {/* <div class="pull-right">
                        <FontAwesomeIcon icon={faClock} />
                        {coursesylbus.map((item) => (
                          <span>
                            {item[1]}
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                          </span>
                        ))}
                      </div> */}
                        <br />
                        <br />
                        <Row>
                          <Col sm={12}>
                            <div class="syl-bg">
                              <div id="de_syllabus">
                                <div class="panel-group">
                                  {outlinelist.map((item, index) => (
                                    <Col lg={12} key={item.outlinename}>
                                      <Accordion
                                        style={{ marginBottom: "13px" }}
                                      >
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1a-content"
                                          id="panel1a-header"
                                        >
                                          <Typography>
                                            {" "}
                                            {item.outlinename}
                                          </Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          <Typography>
                                            {item.tlist.map(
                                              (itemname, index) => (
                                                <>
                                                  <li> {itemname.topicname}</li>
                                                </>
                                              )
                                            )}
                                          </Typography>
                                        </AccordionDetails>
                                      </Accordion>
                                      {/* <div class="panel panel-info">
                                        <div
                                          class="panel-heading"
                                          id="de_heading2"
                                          data-toggle="collapse"
                                          href="#de_syllabus2"
                                          aria-expanded="true"
                                          aria-controls="de_syllabus2"
                                        >
                                          <h6 class="panel-title">
                                            <i class="indicator fa fa-plus"></i>{" "}
                                            {item.outlinename}
                                          </h6>
                                        </div>
                                        <div
                                          id="de_syllabus2"
                                          class="collapse show"
                                          aria-labelledby="de_heading2"
                                          data-parent="#de_syllabus"
                                        >
                                          <div class="panel-body">
                                            <ul class="syllabus-ul">
                                              {item.tlist.map(
                                                (itemname, index) => (
                                                  <>
                                                    <li>
                                                      {" "}
                                                      {itemname.topicname}
                                                    </li>
                                                  </>
                                                )
                                              )}
                                            </ul>
                                          </div>
                                        </div>
                                      </div> */}
                                    </Col>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </Row>
                        <br />
                        <br />
                        {exampolicylist.length > 0 ? (
                          <>
                            <div class="row">
                              <div class="col-lg-12">
                                <h5>Assesment policy</h5>
                                <br />
                                <table style={tableStyle}>
                                  <tr
                                    style={{
                                      backgroundColor: "#337ab7",
                                      color: "#fff",
                                    }}
                                  >
                                    <td>
                                      <b>Type</b>
                                    </td>
                                    <td>
                                      <b>Weightage </b>
                                    </td>
                                  </tr>

                                  {/* <hr /> */}

                                  {exampolicylist.map((item, index) => (
                                    <tr>
                                      <td>{item.examtype}</td>
                                      <td>{item.weightage}</td>
                                    </tr>
                                  ))}
                                </table>
                              </div>
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </div>

                      <div class="col-lg-3">
                        <div class="panel panel-default paper-shadow box_detail">
                          <div class="profile-card">
                            <div class="img-center">
                              {avatarpath === null ? (
                                <>
                                  <img
                                    alt="img"
                                    src="https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg"
                                    class="img-circle"
                                  />
                                </>
                              ) : (
                                <>
                                  <img
                                    alt="img"
                                    src={avatarpath}
                                    class="img-circle"
                                    onError={(e) => {
                                      e.target.src =
                                        "https://s3.ap-south-1.amazonaws.com/myeduplusnow/person/default_avatar.jpg"; //replacement image imported above
                                    }}
                                  />

                                  <p><b>Name : </b>{courseowner}</p>
                                  <p>{yearofExp !== "NA" ? <>Having an Experience of <b>{yearofExp} Years</b></> :""}</p>
                                  <p>{orgName !== "NA" ?<><b>organization </b>: {orgName}</> :"" }</p>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </section>
          <br />
          <section class="explorecourses padding-default ">
            <div class="row ">
              <div class="col-lg-12">
                <div class="bg-purple-gradient">
                  <div class="row ">
                    <div class="col-lg-6">
                      <br />
                      <div class="panel panel-default paper-shadow box_detail">
                        <h5 class="text-center ">
                          {" "}
                          Download The Course Brochure{" "}
                        </h5>
                        <br />
                        <form onSubmit={handleSubmit}>
                          <div class="form-group">
                            <label class="input_label">Your Name</label>
                            <input
                              class="form-control"
                              type="text"
                              value={learnerName}
                              onChange={(e) => setLearnerName(e.target.value)}
                              id="name"
                              name="name"
                            />
                          </div>

                          <div class="form-group">
                            <label class="input_label">Your Email</label>
                            <input
                              class="form-control"
                              type="text"
                              value={learneremail}
                              onChange={(e) => setLearneremail(e.target.value)}
                              id="name"
                              name="name"
                            />
                          </div>
                          <div class="form-group">
                            <label class="input_label">Your Contact No</label>
                            <input
                              class="form-control"
                              type="text"
                              value={learnermob}
                              onChange={(e) => setLearnermob(e.target.value)}
                              id="name"
                              name="name"
                            />
                          </div>
                          <br />
                          <div className="root">
                            <div className="wrapper">
                              <Button
                                type="submit"
                                variant="contained"
                                color="primary"
                                disabled={isLoading}
                                onClick={openModal}
                              >
                                <FontAwesomeIcon icon={faDownload} />{" "}
                                &nbsp;&nbsp; Brochure
                              </Button>
                              {isLoading ? (
                                <CircularProgress
                                  size={24}
                                  color="green"
                                  className="buttonProgress1"
                                />
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </form>
                        {isdownload === true ? (
                          <>
                            {blink == null ? (
                              <>
                                <br />
                                <p>No Document found </p>
                              </>
                            ) : (
                              <>
                                <Modal
                                  isOpen={modalIsOpen}
                                  onRequestClose={closeModal}
                                  size="lg"
                                  style={{
                                    top: "0%",
                                    left: "0%",
                                    right: "0%",
                                    bottom: "0%",
                                    maxWidth: "1600px",
                                    width: "60%",
                                    height: "60%",
                                  }}
                                >
                                  <ModalHeader
                                    toggle={closeModal}
                                  ></ModalHeader>
                                  <ModalBody>
                                    <Row>
                                      <Col xs="10" sm="12" md="12">
                                        <MaterialComponent
                                          contentType="contenttype"
                                          contentId="0"
                                          materialid="0"
                                          materialtype="pdf"
                                          materialpath={blink}
                                        />
                                      </Col>
                                    </Row>
                                  </ModalBody>
                                  <ModalFooter></ModalFooter>
                                </Modal>
                              </>
                            )}
                          </>
                        ) : (
                          <>{/* <Label>Your Contact No</Label> */}</>
                        )}
                      </div>
                    </div>

                    <div class="col-lg-6 text-center" style={certificateStyle}>
                      <br />
                      <p class="text-white pl-3 pr-3">
                        Complete the course successfully to obtain this
                        prestigious recognition from edu plus now
                      </p>
                      <div style={zoom}>
                        <img
                          alt="img"
                          src={certificatepath}
                          style={{ width: "85%",paddingBottom:"15px" }}
                          height="384px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </>
      )}
    </div>
  );
};

export default ExploreCoursepage;
